import { useMemo } from 'react';
import { Breakpoint, useBreakpoint } from '@/lib/providers/BreakpointProvider';

const mobileBreakpoints = new Set<Breakpoint>(['base', 'xs', 'sm']);

export function useIsMobile() {
  const breakpoint: Breakpoint = useBreakpoint();

  return useMemo(() => {
    return mobileBreakpoints.has(breakpoint);
  }, [breakpoint]);
}
